<script setup>
import {computed, defineEmits, defineProps, ref, watch} from "vue";
import {couponConf} from "@/utils/config";
import store from "@/store";
import {ElMessage} from "element-plus";
import ActiveXmairComponent from "@/components/xm-actives/ActiveXmairComponent.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["wjg-scal"];
    }
  }
});
const order_from = computed(() => store.state.orderFrom)
const emit = defineEmits(['login'])
const coupon = computed(() => {
  return props.couponLst?.[0]?.data
})
const step = ref(1);
const product = ref({})
const sendSms = ref(false)
const showPayLoading = ref(false)
const realname = ref(false)
const loading = ref(false)
watch(() => props.account, to => {
  showPayLoading.value = false
  if (Object.keys(to).length && Object.keys(product.value).length) {
    if (parseFloat(to.balance_miles) < product.value?.score_data?.[props.type?.login]?.total) {
      ElMessage.error("可用" + product.value?.score_data?.[props.type?.login]?.unit + '不足')
    }
    showPayLoading.value = true
  }
})
const mobile = ref("")
const number = ref(1)
const payScore = computed(() => {
  return product.value?.score_data?.[props.type?.login]?.total * number.value
})
const maxNumber = computed(() => {
  if (Object.keys(props.account).length < 1 || product.value?.score_data?.[props.type?.login]?.total > parseFloat(props.account?.balance_miles)) return 1;
  return Math.floor(parseFloat(props.account.balance_miles) / parseFloat(product.value?.score_data?.[props.type?.login]?.total))
})
const checkPayment = (cou) => {
  product.value = cou
  if (Object.keys(props.account).length < 1) {
    emit('login');
  } else {
    showPayLoading.value = true
  }
}
const payment = () => {
  if (Object.keys(props.account).length < 1) {
    ElMessage.error("请先登录")
    return
  }
  if (!/^1[2-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("请输入收货手机号");
  }
  if (props.type?.login === "scal" && !sendSms.value) {
    sendSms.value = true;
    return;
  }
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: product.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: number.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (props.type.login !== 'xm_air')
      router.replace({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <div class="wjg-coupon-item">
    <el-image :src="type?.coupon"/>
    <div class="coupon-lst">
      <div class="coupon-item" v-for="coup in coupon" :key="coup.id">
        <div class="coupon-left">
          <div class="coupon-money">
            <span class="coupon-unit">￥</span>
            <span class="coupon-face-money">{{ coup?.face_value }}</span>
          </div>
          <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/logo.png"/>
        </div>
        <div class="coupon-right">
          <div class="coupon-right-its">
            <h5>{{ coup?.name }}</h5>
            <div class="coupon-right-amount">
              <el-text class="coupon-payment-score">
                {{ coup?.score_data?.[type?.login]?.total }}
              </el-text>
              <el-text>
                {{ coup?.score_data?.[type?.login]?.unit }}
              </el-text>
            </div>
          </div>
          <div class="coupon-btn">
            <el-button round @click="checkPayment(coup)"
                       v-if="Object.keys(account).length < 1 || parseFloat(account?.balance_miles) >= coup?.score_data?.[type?.login]?.total">
              立即兑换
            </el-button>
            <el-button disabled round v-else>
              {{ coup?.score_data?.[type?.login]?.unit }}不足
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wjg-coupon-content">
    <div class="wjg-step-items">
      <div class="wjg-step" @click="step=1"></div>
      <div class="wjg-step" @click="step=2"></div>
      <el-image :src="`https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/step${step}.png`"></el-image>
    </div>
    <div class="wjg-coupon-recharge">
      <div v-if="step === 1">
        <ol>
          <li>{{
              type?.login === 'scal' ? '里程' : '积分'
            }}兑换代金券不提供报销凭证，兑换成功不可退换、转售、兑现、找零、拆分使用；
          </li>
          <li>本券兑换成功后，“电子代金券”将以短信形式发送至兑换时填写的手机号，
            <el-text type="danger">请确保兑换时手机号填写正确</el-text>
            ，因手机号码填写错误造成的损失由会员本人承担；
          </li>
          <li>
            本券有效期：短信获取的“电子代金券”需
            <el-text type="danger">60天内</el-text>
            在“diplomat外交官箱包商城”微信小程序内完成绑定，绑定后
            <el-text type="danger">180天内有效</el-text>
            。请在有效期内完成绑定及使用，过期作废，不退不补；
          </li>
          <li>“电子代金券”通过“diplomat外交官箱包商城”微信小程序绑定，支持绑定前转赠；</li>
          <li>如需帮助，请拨打服务热线：4000-360-195。</li>
        </ol>
        <div style="margin: 10px 0">使用方法</div>
        <ol>
          <li>绑卡方法：
            <el-text type="danger">请点击短信内链接</el-text>
            复制“电子兑换码” →微信搜索“diplomat外交官箱包商城”
            小程序→点击【我的】→优惠券→绑定优惠券→输入复制的“电子兑换码”→完成绑定；
          </li>
          <li>绑定后代金券使用规则：
            <ul>
              <li>本券适用于外交官线上商城、线下实体门店（全国）;</li>
              <li>本券使用无门槛限制，可叠加多张使用，使用本券时不与门店其他优惠同享;</li>
              <li>
                外交官线下实体门店：出示小程序内绑定的代金券，结账时使用，可用门店详情请至“diplomat外交官箱包商城”微信小程序内查看;
              </li>
              <li>外交官线上商城小程序：选定商品，提交订单页面，勾选相应代金券，支付时直接抵用;</li>
              <li>本券不记名，不挂失（遗失不补），不转售，不提供兑付或找零，请在有效期内使用。</li>
            </ul>
          </li>
          <li>
            本平台仅是提供会员与商户的兑换服务平台，如遇商品质量问题，请及时与商家联系。
          </li>
        </ol>
      </div>
      <div v-if="step===2">
        <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/step.png"/>
      </div>
    </div>
  </div>
  <active-xmair-component v-if="order_from === 'xm_air'" banner="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/wjg.png"/>
  <el-drawer direction="btt" v-model="showPayLoading" :with-header="false" class="product-drawer" size="500"
             @closed="product={},mobile='',number=1" style="background-color: #FAFAFA">
    <div class="wjg-pay-header">
      <div class="wjg-logo">
        <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/logo.png"/>
      </div>
      <div class="wjg-pay-title">
        <div style="font-weight: 600">{{ product?.name }}</div>
        <div>
          <el-text>无门槛·线上商城/线下门店通用</el-text>
        </div>
        <div class="wjg-pay-money">
          <el-text class="wjg-pay-total">{{ product?.score_data?.[type?.login]?.total }}</el-text>
          <el-text>{{ product?.score_data?.[type?.login]?.unit }}</el-text>
        </div>
      </div>
    </div>
    <div class="wjg-coupon-tips">
      <el-text>
        兑换成功后，代金券将以短信的形式发放至下方
        <el-text type="danger">填写的手机号</el-text>
        ，因手机号填写错误造成的损失由会员本人承担。
      </el-text>
    </div>
    <el-card>
      <div class="wjg-pay-form">
        <div class="wjg-pay-form-label">
          收货手机号
        </div>
        <div class="wjg-pay-form-input">
          <el-input placeholder="请输入收货手机号" v-model="mobile"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="wjg-pay-form">
        <div class="wjg-pay-form-label">
          兑换数量
        </div>
        <div class="wjg-pay-form-input">
          <el-input-number v-model="number" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="wjg-pay-form">
        <div class="wjg-pay-form-label">
          可用{{ type?.login === 'scal' ? '里程' : '积分' }}
        </div>
        <div class="wjg-pay-form-input">
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="wjg-pay-form">
        <div class="wjg-pay-form-label">
          支付{{ type?.login === 'scal' ? '里程' : '积分' }}
        </div>
        <div class="wjg-pay-form-input">
          {{ payScore }}
        </div>
      </div>
    </el-card>
    <div class="wjg-pay-btn">
      <el-button @click="payment" round>立即兑换</el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.wjg-coupon-item {
  margin: 15px;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 10px;
  background: #ffffff;

  .coupon-item {
    display: flex;
    background: url("https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/coupon.png") no-repeat;
    background-size: 100% 100%;

    & + .coupon-item {
      margin-top: 15px;
    }

    .coupon-left {
      width: 22%;
      flex-basis: 22%;
      color: #ffffff;
      box-sizing: border-box;
      padding: 10px 0;
      text-align: center;

      .coupon-money {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;
        padding-top: 10px;

        .coupon-face-money {
          font-size: 1.3rem;
        }

        .coupon-unit {
          font-size: .8rem;
        }
      }

      .el-image {
        padding: 0 10px;
      }
    }

    .coupon-right {
      width: 78%;
      flex-basis: 78%;
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      justify-content: space-between;

      .coupon-right-its {
        line-height: 1.75;

        .coupon-payment-score {
          font-size: 1.45rem;
          color: #56B6C2;
        }
      }

      .coupon-btn {
        margin-top: 30px;
        width: 100px;

        .el-button {
          width: 100%;
          --el-button-bg-color: #56B6C2;
          --el-button-border-color: #56B6C2;
          --el-button-text-color: #fff;
          --el-button-hover-bg-color: #56B6C2;
          --el-button-hover-border-color: #56B6C2;
          --el-button-hover-text-color: #fff;
          --el-button-active-bg-color: #56B6C2;
          --el-button-active-border-color: #56B6C2;
          --el-button-active-text-color: #fff;
          --el-button-disabled-bg-color: #56B6C2;
          --el-button-disabled-border-color: #56B6C2;
          --el-button-disabled-text-color: #fff;
        }
      }
    }
  }
}

.wjg-coupon-content {
  margin: 15px;

  .wjg-step-items {
    display: flex;
    align-items: center;
    position: relative;
    height: 50px;
    justify-content: space-between;
    z-index: 999;

    .wjg-step {
      width: 50%;
      flex-basis: 50%;
      height: 50px;
      position: relative;
      z-index: 999;
    }

    .el-image {
      height: 50px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }

  .wjg-coupon-recharge {
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    border-radius: 0 0 12px 12px;
    text-align: justify;
    line-height: 1.6;

    ol, ul {
      padding-left: 15px;
      font-size: .8rem;

      .el-text {
        font-size: .8rem;
      }

      ul {
        //实心圆点
        list-style: disc;
      }
    }

    .el-image {
      background: #D8E6E8;
      padding: 10px;
      border-radius: 8px;
    }
  }
}

.product-drawer {
  .wjg-pay-header {
    display: flex;
    align-items: stretch;

    .wjg-logo {
      width: 100px;
      flex-basis: 100px;
      margin-right: 10px;
      background: #56B6C2;
      border-radius: 12px;
      box-sizing: border-box;
      position: relative;

      .el-image {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
      }
    }

    .wjg-pay-title {
      line-height: 1.7;

      .el-text {
        font-size: .8rem;
      }
    }

    .wjg-pay-money {
      .wjg-pay-total {
        font-size: 1.5rem;
        color: #56B6C2;
      }
    }
  }

  .wjg-coupon-tips {
    margin: 10px auto;
    line-height: 1.65;
    text-align: justify;

    .el-text {
      font-size: .8rem;

    }
  }

  .el-card {
    --el-card-border-radius: 12px;
    margin-bottom: 15px;

    .wjg-pay-form {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & + .wjg-pay-form {
        padding-top: 10px;
        margin-top: 10px;
        border-top: var(--el-border);
      }
    }
  }

  .wjg-pay-btn {
    .el-button {
      width: 100%;
      --el-button-bg-color: #56B6C2;
      --el-button-border-color: #56B6C2;
      --el-button-text-color: #fff;
      --el-button-hover-bg-color: #56B6C2;
      --el-button-hover-border-color: #56B6C2;
      --el-button-hover-text-color: #fff;
      --el-button-active-bg-color: #56B6C2;
      --el-button-active-border-color: #56B6C2;
      --el-button-active-text-color: #fff;
      --el-button-disabled-bg-color: #56B6C2;
      --el-button-disabled-border-color: #56B6C2;
      --el-button-disabled-text-color: #fff;
    }
  }
}
</style>
